import styled, { css } from 'styled-components';
import { Grid } from '@simplywallst/ui-core';

export const KeyInformationWrapper = styled(Grid)`
  background: ${({ theme }) => theme.color.phantom};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  padding: ${({ theme }) => theme.x2spacePx}px;
  width: 100%;
  height: 100%;
`;

export const Table = styled('table')`
  ${({ theme }) => theme.typography.xSmall}
  width: 100%;
  border-spacing: 0;
  td {
    padding: ${({ theme }) => theme.x1spacePx}px 0px;
    vertical-align: center;
    border-top: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
    &:nth-child(1) {
      opacity: 0.65;
    }
    &:nth-child(2) {
      opacity: 0.85;
      text-align: right;
      white-space: nowrap;
    }
  }
`;

export const Term = styled('span')`
  color: inherit;
  border-bottom: 1px dotted ${({ theme }) => theme.color.brand01};
  cursor: help;
  display: inline-block;
  text-transform: lowercase;

  &:first-letter {
    text-transform: uppercase;
  }
`;

export const TooltipTitle = styled('p')`
  margin: 0;
  max-width: 200px;
  ${({ theme }) => theme.typography.tiny};
`;

type BadgeStyleType = 'positive' | 'warning' | 'negative' | 'none';

const color = (styleType: BadgeStyleType, alpha: number) => {
  if (styleType === 'positive') {
    return css`
      ${({ theme }) => theme.color.goodRGBA(alpha)}
    `;
  }
  if (styleType === 'warning') {
    return css`
      ${({ theme }) => theme.color.warningRGBA(alpha)}
    `;
  }
  if (styleType === 'negative') {
    return css`
      ${({ theme }) => theme.color.badRGBA(alpha)}
    `;
  }
  return css`
    ${({ theme }) => theme.color.lightGrayRGBA(alpha)}
  `;
};

export const Badge = styled('mark')<{ styleType: BadgeStyleType }>`
  padding: 2px 6px;
  background-color: transparent;
  color: ${({ styleType }) => color(styleType, 1)};
  border: 1px solid ${({ styleType }) => color(styleType, 0.2)};
  border-radius: 4px;
`;
